import type { Rollout } from "@/types";
import { RolloutPlan } from "@/config/rollout-plans";

export function useRolloutPlans() {
  const { selectedRollout } = useRolloutRouting();

  const isProfessionalRollout = computed(() => {
    if(selectedRollout.value) {
      return (selectedRollout.value as Rollout).plan >= RolloutPlan.PROFESSIONAL;
    }

    return false;
  });

  const isEnterpriseRollout = computed(() => {
    if(selectedRollout.value) {
      return (selectedRollout.value as Rollout).plan >= RolloutPlan.ENTERPRISE;
    }

    return false;
  });

  return {
    isProfessionalRollout,
    isEnterpriseRollout
  };
}